/**
 * formNavigation.js
 * Helper para navegación estilo desktop en formularios
 * Zero Hardcode - Modular y reutilizable
 */

/**
 * Obtiene todos los campos navegables del formulario
 * @param {Array} fields - Schema fields
 * @param {Object} formData - Datos actuales del formulario
 * @returns {Array} - Lista de nombres de campos navegables
 */
export function getNavigableFields(fields, formData) {
  if (!fields || !Array.isArray(fields)) return [];

  return fields
    .filter(field => {
      // Excluir hidden
      if (field.type === 'hidden') return false;

      // Verificar visibilidad condicional
      if (field.conditionalVisible) {
        const { dependsOn, rules } = field.conditionalVisible;
        const depVal = formData[dependsOn];
        const rule = rules?.find(r => String(r.value) === String(depVal));
        if (rule && rule.visible === false) return false;
      }

      return true;
    })
    .map(field => field.name);
}

/**
 * Obtiene el índice del siguiente campo
 * @param {Array} navigableFields - Lista de campos navegables
 * @param {string} currentField - Campo actual
 * @returns {number} - Índice del siguiente campo (-1 si es el último)
 */
export function getNextFieldIndex(navigableFields, currentField) {
  const currentIndex = navigableFields.indexOf(currentField);
  
  if (currentIndex === -1) return 0; // Si no se encuentra, ir al primero
  if (currentIndex >= navigableFields.length - 1) return -1; // Es el último
  
  return currentIndex + 1;
}

/**
 * Verifica si un campo es el último navegable
 * @param {Array} navigableFields - Lista de campos navegables
 * @param {string} fieldName - Nombre del campo
 * @returns {boolean}
 */
export function isLastField(navigableFields, fieldName) {
  const index = navigableFields.indexOf(fieldName);
  return index === navigableFields.length - 1;
}

/**
 * Obtiene el primer campo navegable
 * @param {Array} navigableFields - Lista de campos navegables
 * @returns {string|null} - Nombre del primer campo o null
 */
export function getFirstField(navigableFields) {
  return navigableFields.length > 0 ? navigableFields[0] : null;
}